<template>
  <div
    :class="[$style.track, { [$style.inverted]: appearance === 'inverted' }]"
    role="progressbar"
    :aria-valuenow="clampedValue"
    aria-valuemin="0"
    aria-valuemax="100"
  >
    <div :class="[$style.fill, { [$style.alert]: alert }]" :style="{ width: `${clampedValue}%` }" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    /** Completion in percent. Values outside 0–100 are clamped. */
    value?: number;
    alert?: boolean;
    /** "inverted" swaps the track to the inverted (white) fill for use on a tinted card background. */
    appearance?: "default" | "inverted";
  }>(),
  {
    value: 0,
    alert: false,
    appearance: "default",
  },
);

const clampedValue = computed(() => Math.min(100, Math.max(0, Math.round(props.value))));
</script>

<style lang="scss" module>
.track {
  width: 100%;
  height: 6px;
  border-radius: var(--border-radius-medium);
  background-color: var(--color-interaction-neutral-subtle-normal);
  overflow: hidden;

  &.inverted {
    background-color: var(--color-interaction-inverted-normal);
  }
}
.fill {
  height: 100%;
  border-radius: var(--border-radius-medium);
  background-color: var(--color-interaction-default-normal);
  transition: width 0.2s linear;

  &.alert {
    background-color: var(--color-interaction-border-alert);
  }
}
</style>
